export function resolveStepItemProps(params: {
  onClick: (() => void) | undefined;
  isSelected: boolean;
}) {
  const isInteractive = !!params.onClick;
  return {
    element: isInteractive ? ('button' as const) : ('div' as const),
    type: isInteractive ? ('button' as const) : undefined,
    role: isInteractive ? ('tab' as const) : undefined,
    ariaSelected: isInteractive ? params.isSelected : undefined,
  };
}

export function resolveContainerProps(params: { hasStepClick: boolean }) {
  return {
    role: params.hasStepClick ? ('tablist' as const) : undefined,
  };
}
